<svelte:options customElement={{ tag: "bt-ai-logo", shadow: "none", }} />

<script lang="ts">
	export let size: String= "1rem";
</script>

<div class="ai-loader" style={`--ai-loader-size: ${size}`}>
	<div class="ai-loader__cube">
	  <div class="ai-loader__cube__face ai-loader__cube__face--front"></div>
	  <div class="ai-loader__cube__face ai-loader__cube__face--back"></div>
	  <div class="ai-loader__cube__face ai-loader__cube__face--left"></div>
	  <div class="ai-loader__cube__face ai-loader__cube__face--right"></div>
	  <div class="ai-loader__cube__face ai-loader__cube__face--top">
	    <div class="ai-loader__cube__plus--square ai-loader__cube__plus--square--vertical"></div>
	    <div class="ai-loader__cube__plus--square ai-loader__cube__plus--square--horizontal"></div>
	    <div class="ai-loader__cube__plus--square ai-loader__cube__plus--square--inner"></div>
	  </div>
	  <div class="ai-loader__cube__face ai-loader__cube__face--bottom"></div>
	</div>
</div>

<style>
.ai-loader {
	width: var(--ai-loader-size);
	height: var(--ai-loader-size);
	position: relative;
}

.ai-loader__cube {
	width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transform: translateZ(-100px) rotateX(-30deg) rotateY(45deg);
}

.ai-loader__cube__face {
	position: absolute;
  width: var(--ai-loader-size);
  height: var(--ai-loader-size);
  box-sizing: border-box;
  outline: 1px solid transparent;
}

.ai-loader__cube__face--front {
	transform: rotateY(0deg) translateZ(calc(var(--ai-loader-size) / 2));
  background: orange;
  background: #FBC435;
  border: 1px solid #FBC435;
}
.ai-loader__cube__face--right {
	transform: rotateY(90deg) translateZ(calc(var(--ai-loader-size) / 2));
  background: transparent;
}
.ai-loader__cube__face--back { 
  transform: rotateY(180deg) translateZ(calc(var(--ai-loader-size) / 2));
  background: transparent;
}
.ai-loader__cube__face--left {
	transform: rotateY(-90deg) translateZ(calc(var(--ai-loader-size) / 2));
  background: orange;
  background: #021B87;
  border: 1px solid #021B87;
}
.ai-loader__cube__face--top {
	transform: rotateX( 90deg) translateZ(calc(var(--ai-loader-size) / 2));
  background: orange;
  background: white;
  box-sizing: border-box;
}
.ai-loader__cube__face--bottom {
	transform: rotateX(-90deg) translateZ(calc(var(--ai-loader-size) / 2));
  background:  #FBC435;
}
.ai-loader__cube__plus--square {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
	outline: 1px solid transparent;
}

.ai-loader__cube__plus--square--vertical,
.ai-loader__cube__plus--square--horizontal {
	background: #000000;
	width: var(--ai-loader-size);
	height: var(--ai-loader-size);
}

.ai-loader__cube__plus--square--inner {
	background: #FFFFFF;
	width: calc(var(--ai-loader-size) * .6);
	height: calc(var(--ai-loader-size) * .6);
}
</style>
